import { useGetDateTimeQuery } from 'views/utils/graphql/graphql';

export const useGetDateTime = () => {
  const [dateTime, getDataTime] = useGetDateTimeQuery({
    variables: {},
    requestPolicy: 'network-only',
    pause: true,
  });
  return {
    dateTime,
    getDataTime,
  };
};
